export default __webpack_public_path__ + "static/media/Fábio Caio_.ccb64948.png";